export const redirectGuard = (...payload) => {
  const [,, next, clause, redirectTo] = payload
  clause ? next(redirectTo) : next()
}
